import React, { useCallback } from 'react';
import { Link, useLocation } from "react-router-dom";
import * as FeatherIcon from 'react-feather';
import { useUser } from '../../context/UserContext';
// **FIXED IMPORT PATH**
import { getUserStatsObject, recordActivity } from '../../services/commonService'; 


export default function UserPreferenceSidebar() {
  var pathname = useLocation().pathname;
  var progress_bar_width = 33;
  
  const { user } = useUser();
  const current_role_key = user?.role_key;

  if (pathname === '/user_profile/profile'){
    progress_bar_width = 33;
  }else if(pathname === '/user_profile/business_segment'){
    progress_bar_width = 66;
  }else if(pathname === '/user_profile/company_profile'){
    progress_bar_width = 100;
  }

  // Handler function to record activity on click
  const recordProfileActivity = useCallback(() => {
    if (!user?.id) {
      return;
    }

    // Log Type: "General" (as requested)
    const pageName = "General"; 
    const actionType = "page_load";
    const dataDetails = `Page Load: ${pageName} (Click)`;
    const targetUrl = "/users/view_profile"; 
    const contextualId = user.id; 

    const userStat = getUserStatsObject(
      pageName,
      actionType,
      dataDetails,
      window.location.href, // Current URL before navigation
      contextualId
    );
    
    userStat.url_details = {
      page: targetUrl,
      page_params: {},
      query_params: {}
    };

    recordActivity(userStat);
  }, [user?.id]); 

  return (
    <div>  
      <div className='progress_bar_block mb-2'>
        <h5 className='progress_head'>My Profile</h5>
        {/* <div className="progress">
          <div className="progress-bar bg-success" style={{width:progress_bar_width+'%'}}></div>
        </div> */}
      </div>

      <ul className='profile_sidebar_ul'>
        <li className={`profile_sidebar_li ${pathname === '/users/view_profile' ? 'active' : ''}`}>
          {/* Attached onClick handler to fire API before navigating */}
          <Link className='link_sidebar' to={{ pathname: "/users/view_profile" }}
            onClick={recordProfileActivity} // <-- API call fires on click
>
            <FeatherIcon.User className='img_trend' /> General
          </Link>
        </li>

        {/* <li className={`profile_sidebar_li ${pathname === '/users/change_password' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/change_password" }}><FeatherIcon.Key className='img_trend' /> Change Password</Link>
        </li> */}

        <li className={`profile_sidebar_li ${pathname === '/users/personalisation' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/personalisation" }}><FeatherIcon.Key className='img_trend' /> Settings </Link>
        </li>

        {/* {current_role_key === 'CLIENT' &&
        <li className={`profile_sidebar_li ${pathname === '/manage_accounts' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/manage_accounts" }}><FeatherIcon.Box className='img_trend' /> Accounts & Users</Link>
        </li>
        } */}


        {/* {(current_role_key === 'CLIENT_EMPLOYEE' 
          || current_role_key === 'CLIENT')
          && (<li className={`profile_sidebar_li ${pathname === '/users/upload_documents' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/users/upload_documents" }}><FeatherIcon.FileText className='img_trend' /> Documents</Link>
        </li>)} */}

        {/* <li className={`profile_sidebar_li ${pathname === '/user_profile/company_profile' ? 'active' : ''}`}>
          <Link className='link_sidebar' to={{ pathname: "/user_profile/company_profile" }}><FeatherIcon.Briefcase className='img_trend' /> Select Accounts</Link>
        </li> */}
        {/* <li className='profile_sidebar_li'><a href="#" className='link_sidebar'><img src="/img/icons/profile/industry.png" className="img_trend" alt="profile"/> Enter business segments</a></li> */}
      </ul>
    </div>
  )
}
